import React, { useEffect, useState } from "react";
import { ShoppingBag, Clock, MessageSquare, Package } from "lucide-react";
import { apiAdmin, formatCLP } from "../../lib/api";

const Dashboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    apiAdmin.get("/admin/dashboard").then((r) => setData(r.data));
  }, []);

  if (!data) return <p className="text-gray-400">Cargando dashboard...</p>;

  const stats = [
    { label: "Total pedidos", value: data.total_orders, icon: ShoppingBag, bg: "bg-mint-deep", text: "text-white" },
    { label: "Pedidos pendientes", value: data.pending_orders, icon: Clock, bg: "bg-yolk", text: "text-white" },
    { label: "Cotizaciones nuevas", value: data.pending_quotes, icon: MessageSquare, bg: "bg-cyan-brand", text: "text-white" },
    { label: "Productos activos", value: data.total_products, icon: Package, bg: "bg-white", text: "text-brand-ink" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-10">
        <span className="text-xs uppercase tracking-[0.25em] font-bold text-yolk">─ Panel ─</span>
        <h1 className="mt-2 font-heading text-4xl font-bold text-brand-ink">Dashboard</h1>
        <p className="text-gray-600 mt-1 text-sm">Resumen de la tienda en tiempo real.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        {stats.map((s, i) => (
          <div key={s.label} className={`${s.bg} ${s.text} border-2 border-black rounded-3xl p-6 transition-transform hover:-translate-y-1 hover:rotate-[-0.5deg] hover:shadow-[6px_6px_0_0_#1A1333]`} style={{ transform: `rotate(${(i % 2 === 0 ? -0.3 : 0.3)}deg)` }}>
            <div className="flex items-center gap-3 mb-4">
              <div className={`h-10 w-10 rounded-full flex items-center justify-center ${s.bg === "bg-white" ? "bg-mint-light" : "bg-white/20"}`}>
                <s.icon className="h-5 w-5" />
              </div>
            </div>
            <p className={`text-[10px] uppercase tracking-[0.18em] font-bold ${s.bg === "bg-white" ? "text-gray-400" : "opacity-80"} mb-1`}>{s.label}</p>
            <p className="font-heading text-4xl font-extrabold">{s.value}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white border-2 border-black rounded-3xl overflow-hidden">
          <div className="px-6 py-4 bg-mint-deep text-white border-b-2 border-black">
            <h3 className="font-heading text-lg font-bold">📦 Pedidos recientes</h3>
          </div>
          <div className="divide-y-2 divide-black/10">
            {data.recent_orders.length === 0 ? (
              <p className="p-6 text-sm text-gray-400 text-center">Sin pedidos aún</p>
            ) : (
              data.recent_orders.map((o) => (
                <div key={o.id} className="p-4 flex items-center justify-between hover:bg-yolk-light/40 transition">
                  <div>
                    <p className="text-sm font-bold text-brand-ink">{o.nombre}</p>
                    <p className="text-xs text-gray-500 mt-0.5">{o.items.length} items · <span className="capitalize px-2 py-0.5 bg-mint-light rounded-full text-[10px] font-bold text-mint-dark">{o.status}</span></p>
                  </div>
                  <p className="text-sm font-bold text-yolk">{o.total ? formatCLP(o.total) : "Cotizar"}</p>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="bg-white border-2 border-black rounded-3xl overflow-hidden">
          <div className="px-6 py-4 bg-yolk text-white border-b-2 border-black">
            <h3 className="font-heading text-lg font-bold">💬 Cotizaciones recientes</h3>
          </div>
          <div className="divide-y-2 divide-black/10">
            {data.recent_quotes.length === 0 ? (
              <p className="p-6 text-sm text-gray-400 text-center">Sin cotizaciones aún</p>
            ) : (
              data.recent_quotes.map((q) => (
                <div key={q.id} className="p-4 hover:bg-yolk-light/40 transition">
                  <div className="flex items-center justify-between mb-1">
                    <p className="text-sm font-bold text-brand-ink">{q.nombre}</p>
                    <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 bg-yolk-light text-yolk font-bold rounded-full">{q.status}</span>
                  </div>
                  <p className="text-xs text-gray-500">{q.servicio}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
